import { LogLevel } from '@azure/msal-browser';

// MSAL configuration for Microsoft Entra ID authentication
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: import.meta.env.VITE_AZURE_TENANT_ID
      ? `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`
      : 'https://login.microsoftonline.com/organizations',
    redirectUri: import.meta.env.VITE_REDIRECT_URI || 'http://localhost:5173',
    postLogoutRedirectUri:
      import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || 'http://localhost:5173',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage' as const,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }

        const isProduction = import.meta.env.PROD;

        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            return;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            return;
          case LogLevel.Info:
            if (!isProduction) {
              console.info('[MSAL]', message);
            }
            return;
          case LogLevel.Verbose:
            if (!isProduction) {
              console.debug('[MSAL]', message);
            }
            return;
          default:
            return;
        }
      },
      logLevel: import.meta.env.PROD ? LogLevel.Warning : LogLevel.Info,
    },
  },
};

// Login request scopes
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
  forceRefresh: false,
};
